export default __webpack_public_path__ + "static/media/Available_ios.d1268b45.svg";